import { render, staticRenderFns } from "./RightsRequestForm.vue?vue&type=template&id=1f510047&scoped=true"
import script from "./RightsRequestForm.vue?vue&type=script&lang=js"
export * from "./RightsRequestForm.vue?vue&type=script&lang=js"
import style0 from "./RightsRequestForm.vue?vue&type=style&index=0&id=1f510047&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f510047",
  null
  
)

export default component.exports